export type CanonicalMovementType = 'Truck' | 'Rail' | 'MCT' | 'MBL' | '';

export const resolveMovementType = (value?: string): CanonicalMovementType => {
  const rawValue = String(value ?? '').trim();
  if (!rawValue) {
    return '';
  }

  const compactValue = rawValue
    .toUpperCase()
    .replace(/[_-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  const tokenValue = compactValue.replace(/\s/g, '');

  const truckAliases = new Set(['TRUCK', 'TRK']);
  const railAliases = new Set(['RAIL', 'RLS']);
  const mctAliases = new Set(['MCT', 'MARINECONTAINERTRANSPORT']);
  const marineBulkAliases = new Set(['MBL', 'MARINEBULK', 'BULKMARINE']);

  if (truckAliases.has(tokenValue) || compactValue.includes('TRUCK')) {
    return 'Truck';
  }

  if (railAliases.has(tokenValue) || compactValue.includes('RAIL')) {
    return 'Rail';
  }

  if (mctAliases.has(tokenValue) || compactValue.includes('MARINE CONTAINER TRANSPORT')) {
    return 'MCT';
  }

  if (marineBulkAliases.has(tokenValue) || compactValue.includes('MARINE BULK') || compactValue.includes('BULK MARINE')) {
    return 'MBL';
  }

  return '';
};